import { afterLogout, logout } from "@/services/signin";
import store from "@/store";
import { UserModule } from "@/store/modules/user";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";

// 可以封装一个等待 uni 对象的方法
function waitForUni(timeout = 5000): Promise<any> {
  return new Promise((resolve, reject) => {
    if ((window as any).uni) {
      resolve((window as any).uni);
      return;
    }

    const timer = setTimeout(() => {
      reject(new Error("UniApp environment not ready"));
    }, timeout);

    document.addEventListener(
      "UniAppJSBridgeReady",
      () => {
        clearTimeout(timer);
        resolve((window as any).uni);
      },
      { once: true },
    );
  });
}

export interface ISigninState {
  apiLoadingStatus: any;
}

@Module({ dynamic: true, store, name: "signin" })
class Signin extends VuexModule implements ISigninState {
  public apiLoadingStatus = false;

  @Mutation
  private SET_APILOADINGSTATUS(status: any) {
    this.apiLoadingStatus = status;
  }

  // 请求状态全局
  @Action
  public async loadingStatus(data: any) {
    this.SET_APILOADINGSTATUS(data);
  }

  // 子应用登录
  @Action
  public async login() {
    const res: any = await afterLogout("");
    if (res.success) {
      // try {
      //   document.addEventListener("UniAppJSBridgeReady", function () {
      //     const uni = (window as any).uni;
      //     console.log("跳转页面");
      //     uni.redirectTo({
      //       url: "/pages/SamBoard/index",
      //     });
      //   });
      // } catch (error) {
      //   console.log("error: ", error);
      // }
      const res2: any = await UserModule.getUserInfo();
      UserModule.setCanGetUser(false);
      console.log("获取用户信息返回值", res2, res2.tenant);
      if (res2.tenant) {
        console.log("准备跳转");
        try {
          const uni = await waitForUni();
          console.log("uni: ", uni);
          uni.redirectTo({
            url: "/pages/SamBoard/index",
            fail: (err: any) => {
              console.log("跳转失败", err);
            },
          });
        } catch (error) {
          console.error("Failed to get uni object:", error);
        }
      }
    }
  }

  // 子应用 登出
  @Action
  public async LogOut() {
    const { data } = await logout("");
    await afterLogout(data.pflow);
  }
}

export const SigninModule = getModule(Signin);
